'use strict';

var _require = require('./utils/isPromise'),
    isPromise = _require.isPromise;

var _require2 = require('./utils/either'),
    sequence = _require2.sequence,
    try_ = _require2.try_;

var _require3 = require('./action'),
    fromError = _require3.fromError,
    fromSuccess = _require3.fromSuccess;

var createTransition = require('./utils/transition');

var _require4 = require('./commands'),
    isCommand = _require4.isCommand,
    isImmediateCommand = _require4.isImmediateCommand,
    isQueuedCommand = _require4.isQueuedCommand;

var registrar = function registrar(list) {
  return function (fn) {
    list.push(fn);
    return function () {
      var index = list.indexOf(fn);
      if (index >= 0) {
        list.splice(index, 1);
      }
    };
  };
};

var createMiddleware = function createMiddleware(extraArgument) {
  var subscribers = [];
  var executors = {};
  var queuePromise = Promise.resolve();

  var middleware = function middleware(store) {
    return function (next) {
      return function (action) {
        var executeCommand = function executeCommand(cmd) {
          var result = try_(function () {
            return executors[cmd.type](cmd.command);
          });
          return result.fold(function (error) {
            var downstreamPromise = cmd.actionType ? store.dispatch(fromError(cmd.actionType, error)) : Promise.resolve();
            return [result, downstreamPromise];
          }, function (value) {
            if (isPromise(value)) {
              var downstreamPromise = value.then(function (resolvedValue) {
                return cmd.actionType ? store.dispatch(fromSuccess(cmd.actionType, resolvedValue)) : Promise.resolve();
              }, function (error) {
                if (cmd.actionType) {
                  store.dispatch(fromError(cmd.actionType, error)).catch(function () {});
                }
                throw error;
              });
              return [result, downstreamPromise];
            } else {
              var _downstreamPromise = cmd.actionType ? store.dispatch(fromSuccess(cmd.actionType, value)) : Promise.resolve();
              return [result, _downstreamPromise];
            }
          });
        };

        var runImmediateCommands = function runImmediateCommands(commands) {
          var immediateCommands = commands.filter(isImmediateCommand);
          var promiseTuples = immediateCommands.map(executeCommand);
          promiseTuples.map(function (tuple) {
            return tuple[0];
          }).map(function (result) {
            return result.fold(function (error) {
              throw error;
            }, function (value) {
              return value;
            });
          });
          promiseTuples.map(function (tuple) {
            return tuple[1];
          }).map(function (downstreamPromise) {
            return downstreamPromise.catch(function () {});
          });
          return commands.filter(isQueuedCommand);
        };

        var executeQueuedCommands = function executeQueuedCommands(resolve, reject) {
          return function (commands) {
            if (commands.length > 0) {
              var promiseTuples = commands.filter(isQueuedCommand).map(executeCommand);
              Promise.all(promiseTuples.map(function (tuple) {
                return tuple[1];
              })).then(function () {
                return resolve();
              }, reject);

              return Promise.all(promiseTuples.map(function (tuple) {
                return tuple[0];
              }).map(function (result) {
                return result.fold(function (error) {
                  return Promise.reject(error);
                }, function (value) {
                  return value;
                });
              })).catch(reject);
            } else {
              resolve();
              return Promise.resolve();
            }
          };
        };

        var scheduleExecution = function scheduleExecution() {
          var trigger = undefined;
          var gate = new Promise(function (resolve) {
            return trigger = resolve;
          });
          var promise = new Promise(function (resolve, reject) {
            queuePromise = queuePromise.then(function () {
              return gate;
            }).then(executeQueuedCommands(resolve, reject), reject).catch(reject);
          });

          return { promise: promise, trigger: trigger };
        };

        var queueAndRunCommands = function queueAndRunCommands(commands) {
          var _scheduleExecution = scheduleExecution(),
              promise = _scheduleExecution.promise,
              trigger = _scheduleExecution.trigger;

          return try_(function () {
            return runImmediateCommands(commands);
          }).fold(function (e) {
            if (trigger) {
              trigger([]);
            }
            throw e;
          }, function (commands) {
            if (trigger) {
              trigger(commands);
            }
            return promise;
          });
        };

        var from = store.getState();
        var result = next(action);
        var to = store.getState();

        if (from !== to) {
          var transition = createTransition(from, to);
          var issuedCommands = sequence(subscribers.slice().map(function (subscriber) {
            return try_(function () {
              return subscriber(transition, extraArgument) || [];
            });
          }));

          return issuedCommands.fold(function (e) {
            throw e;
          }, function (commands) {
            return queueAndRunCommands(commands.filter(isCommand));
          });
        }

        return Promise.resolve(result);
      };
    };
  };

  var subscribe = registrar(subscribers);

  var registerExecutors = function registerExecutors() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    args.forEach(function (executor) {
      return executors[executor.type] = executor.execute;
    });
  };

  return {
    middleware: middleware,
    registerExecutors: registerExecutors,
    subscribe: subscribe
  };
};

module.exports = createMiddleware;


//////////////////
// WEBPACK FOOTER
// ../node_modules/redux-serial-effects/dist/middleware.js
// module id = 260
// module chunks = 0